import ScrollMagic from 'scrollmagic';

export default function pinsArticleSidebar() {

    $(window).on('load', function () {

        if ($('.sidebar').length > 0) {

            let sidebarController = new ScrollMagic.Controller(),
                $sidebar = $('.sidebar'),
                articleScrollLength = $('.article__main').innerHeight() - $sidebar.innerHeight();
            // console.log(articleScrollLength);

            let fixedSidebar = new ScrollMagic.Scene({
                offset: -72,
                triggerElement: '.article',
                duration: articleScrollLength,
                triggerHook: 0,
            })
                .addTo(sidebarController);

            if ($sidebar.length > 0 && $(window).width() < 1199 || articleScrollLength < 0) {
                fixedSidebar.removePin('.sidebar');
            } else {
                fixedSidebar.setPin('.sidebar');
            }

            $(window).on('resize', function () {
                if ($sidebar.length > 0 && $(window).width() < 1199 || articleScrollLength < 0) {
                    if($('.scrollmagic-pin-spacer').length > 0) {
                        fixedSidebar.removePin('.sidebar');
                        // console.log('remove');
                    }
                }
                if ($sidebar.length > 0 && $(window).width() >= 1200 && articleScrollLength > 0) {
                    if($('.scrollmagic-pin-spacer').length <= 0) {
                        fixedSidebar.setPin('.sidebar');
                        // console.log('set');
                    }
                }
            });

            // console.log(articleScrollLength);

        }

    });
}